import { render, staticRenderFns } from "./FoldersTable.vue?vue&type=template&id=4ba9edbd"
import script from "./FoldersTable.vue?vue&type=script&lang=js"
export * from "./FoldersTable.vue?vue&type=script&lang=js"
import style0 from "./FoldersTable.vue?vue&type=style&index=0&id=4ba9edbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports